import { Skeleton } from "primereact/skeleton";
import { specialityModesApi } from "../../services/nomenclatures/specialityModesApi";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import { RootState } from "../../store";
import { SpecialityModeResponse } from "../../models/dtos";
import Error from "../common/Error";
import FilterBox from "./FilterBox";

type EduFormFilterProps = {
  getSelectedEduForms: (state: RootState) => SpecialityModeResponse[];
  setSelectedEduForms: any;
};

const EduFormFilter = ({ getSelectedEduForms, setSelectedEduForms }: EduFormFilterProps) => {
  const selectedEduForms = useSelector(getSelectedEduForms);
  const dispatch = useAppDispatch();

  const { data: eduForms, error, isLoading } = specialityModesApi.useGetSpecialityModesQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По обучение:">
      <FilterBox<SpecialityModeResponse>
        value={selectedEduForms}
        onChange={(e) => dispatch(setSelectedEduForms(e.value))}
        options={eduForms?.data ?? []}
        optionLabel="name"
        listClassName="max-h-24rem"
        dataKey="specialityModeId"
      />
    </FilterCard>
  );
};

export default EduFormFilter;
